import { render, staticRenderFns } from "./CustomerUserTable.vue?vue&type=template&id=1305ac44&"
import script from "./CustomerUserTable.vue?vue&type=script&lang=js&"
export * from "./CustomerUserTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports